<template>
  <HeaderContent title="Title"/>
  <ActionContent ctaText="Add Reservation"/>
  <DataTable :data="data" :header="headers" :currentPage="currentPage" :custom-actions="customActions">
    
  </DataTable>
</template>

<script>
import { ref } from 'vue';
import DataTable from '@/components/DataTable.vue';
import HeaderContent from '@/components/HeaderContent.vue';
import ActionContent from '@/components/ActionContent.vue';
import { 
    // BButton, 
    // BBadge 
} from 'bootstrap-vue-next';

export default {
    name: 'TestView',

    components: {
        DataTable,
        HeaderContent,
        ActionContent,
        // BBadge,
        // BButton
    },
    setup(){
        const currentPage = ref(1)

        const data = ref([
            { 
                no: 1, 
                reservation_no: 'DR-01/11/02/2024', 
                type_room: 'Deluxe', 
                no_room: 'A3', 
                guest_name: 'Mr Bones', 
                arrival: '11/02/2025',
                departure: '13/02/2025',
                total_day: '2',
                payment_status: 'DP',
                paid: '600.000',
                balance: '1.000.000',
                status: 'checkin',
            },
            { 
                no: 2, 
                reservation_no: 'DR-01/11/02/2024', 
                type_room: 'Family', 
                no_room: 'A2', 
                guest_name: 'Mr John', 
                arrival: '11/02/2025',
                departure: '13/02/2025',
                total_day: '2',
                payment_status: 'DP',
                paid: '600.000',
                balance: '2.000.000',
                status: 'inhouse',
            },
            { 
                no: 2, 
                reservation_no: 'DR-01/11/02/2024', 
                type_room: 'Family', 
                no_room: 'A2', 
                guest_name: 'Mr John', 
                arrival: '11/02/2025',
                departure: '13/02/2025',
                total_day: '2',
                payment_status: 'DP',
                paid: '600.000',
                balance: '2.000.000',
                status: 'inhouse',
            },
            { 
                no: 2, 
                reservation_no: 'DR-01/11/02/2024', 
                type_room: 'Family', 
                no_room: 'A2', 
                guest_name: 'Mr John', 
                arrival: '11/02/2025',
                departure: '13/02/2025',
                total_day: '2',
                payment_status: 'DP',
                paid: '600.000',
                balance: '2.000.000',
                status: 'inhouse',
            },
            { 
                no: 2, 
                reservation_no: 'DR-01/11/02/2024', 
                type_room: 'Family', 
                no_room: 'A2', 
                guest_name: 'Mr John', 
                arrival: '11/02/2025',
                departure: '13/02/2025',
                total_day: '2',
                payment_status: 'DP',
                paid: '600.000',
                balance: '2.000.000',
                status: 'inhouse',
            },
            { 
                no: 2, 
                reservation_no: 'DR-01/11/02/2024', 
                type_room: 'Family', 
                no_room: 'A2', 
                guest_name: 'Mr John', 
                arrival: '11/02/2025',
                departure: '13/02/2025',
                total_day: '2',
                payment_status: 'DP',
                paid: '600.000',
                balance: '2.000.000',
                status: 'inhouse',
            },
            { 
                no: 2, 
                reservation_no: 'DR-01/11/02/2024', 
                type_room: 'Family', 
                no_room: 'A2', 
                guest_name: 'Mr John', 
                arrival: '11/02/2025',
                departure: '13/02/2025',
                total_day: '2',
                payment_status: 'DP',
                paid: '600.000',
                balance: '2.000.000',
                status: 'inhouse',
            },
            { 
                no: 2, 
                reservation_no: 'DR-01/11/02/2024', 
                type_room: 'Family', 
                no_room: 'A2', 
                guest_name: 'Mr John', 
                arrival: '11/02/2025',
                departure: '13/02/2025',
                total_day: '2',
                payment_status: 'DP',
                paid: '600.000',
                balance: '2.000.000',
                status: 'inhouse',
            },
            { 
                no: 2, 
                reservation_no: 'DR-01/11/02/2024', 
                type_room: 'Family', 
                no_room: 'A2', 
                guest_name: 'Mr John', 
                arrival: '11/02/2025',
                departure: '13/02/2025',
                total_day: '2',
                payment_status: 'DP',
                paid: '600.000',
                balance: '2.000.000',
                status: 'inhouse',
            },
            { 
                no: 2, 
                reservation_no: 'DR-01/11/02/2024', 
                type_room: 'Family', 
                no_room: 'A2', 
                guest_name: 'Mr John', 
                arrival: '11/02/2025',
                departure: '13/02/2025',
                total_day: '2',
                payment_status: 'DP',
                paid: '600.000',
                balance: '2.000.000',
                status: 'inhouse',
            },
            { 
                no: 2, 
                reservation_no: 'DR-01/11/02/2024', 
                type_room: 'Family', 
                no_room: 'A2', 
                guest_name: 'Mr John', 
                arrival: '11/02/2025',
                departure: '13/02/2025',
                total_day: '2',
                payment_status: 'DP',
                paid: '600.000',
                balance: '2.000.000',
                status: 'inhouse',
            },
        ])

        const headers = ref([
        {
            key: 'reservation_no',
            label: 'Reservation No',
            sortable: true,
        },
        {
            key: 'type_room',
            label: 'Room Type',
            sortable: true,
        },
        {
            key: 'no_room',
            label: 'Room Number',
            sortable: true,
        },
        {
            key: 'guest_name',
            label: 'Guest Name', 
            sortable: true,
        },
        {
            key: 'arrival',
            label: 'Arrival', 
            sortable: true,
        },
        {
            key: 'departure',
            label: 'Departure', 
            sortable: true,
        },
        {
            key: 'total_day',
            label: 'Total Day', 
            sortable: true,
        },
        {
            key: 'payment_status',
            label: 'Payment Status', 
            sortable: true,
        },
        {
            key: 'paid',
            label: 'Paid', 
            sortable: false,
        },
        {
            key: 'balance',
            label: 'Balance', 
            sortable: false,
        },
        {
            key: 'status',
            label: 'Status', 
            sortable: false,
        },
        {
            key: 'action',
            label: 'Actions'
        },
        
        ])

        const customActions = ref([
        {
            label: 'Edit',
            variant: 'success',
            icon: 'fas fa-edit',
            action: (item) => {
            console.log('Edit action clicked for:', item);
            // Implement your edit logic here
            }
        },
        {
            label: 'Delete',
            variant: 'danger',
            icon: 'fas fa-trash',
            action: (item) => {
            console.log('Delete action clicked for:', item);
            // Implement your delete logic here
            }
        },
        {
            label: 'Extra Charge',
            variant: 'warning',
            icon: 'fas fa-bolt',
            action: (item) => {
            console.log('Extra charge action clicked for:', item);
            // Implement your extra charge logic here
            }
        },
        ]);

        
        return{
            data,
            headers,
            currentPage,
            customActions,
        }
    }

}
</script>

<style>

</style>